if (!customElements.get('metal-swatches')) {
  customElements.define(
    'metal-swatches',
    class MetaSwatches extends HTMLElement {
      classes = {
        active: 'metal-swatches__item--active',
        cardHover: 'card-wrapper--disable-media-hover',
      };

      selectors = {
        item: '.metal-swatches__item',
        cardLink: '.card__heading > a',
        cardPrice: '.card-information .price__regular .price-item',
        cardComparePrice: '.card-information .price__sale .price-item',
        card: '.card-wrapper',
        carProductMedia: '.card__media .media',
        mediaHoverEffect: '.media.media--hover-effect',
      };

      constructor() {
        super();

        this.swatches = this.querySelectorAll(this.selectors.item);
        this.mediaHoverEnabled = this.swatches[0]
          .closest(this.selectors.card)
          .querySelector(this.selectors.mediaHoverEffect);
        this.setupEventListeners();
      }

      setupEventListeners() {
        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', this.onSwatchClick.bind(this));
        });

        const desktop = window.matchMedia('(min-width: 1024px)').matches;
        if (desktop && this.mediaHoverEnabled) {
          const card = this.closest(this.selectors.card);
          if (card) {
            this.addEventListener('mouseenter', () => {
              card.classList.add(this.classes.cardHover);
            });
            this.addEventListener('mouseleave', () => {
              card.classList.remove(this.classes.cardHover);
            });
          }
        }
      }

      onSwatchClick(event) {
        const swatch = event.currentTarget;

        this.swatches.forEach((item) => {
          item.classList.remove('metal-swatches__item--active');
        });

        swatch.classList.add('metal-swatches__item--active');

        const swatchTitle = swatch.dataset.productTitle;
        const swatchLink = swatch.dataset.productUrl;
        const swatchPrice = swatch.dataset.productPrice;
        const swatchComparePrice = swatch.dataset.productComparePrice;
        const swatchMedia = swatch.dataset.productMedia;

        const card = swatch.closest(this.selectors.card);

        if (!card) return;

        const cardLinks = card.querySelectorAll(this.selectors.cardLink);
        const cardPrice = card.querySelector(this.selectors.cardPrice);
        const cardComparePrice = card.querySelector(this.selectors.cardComparePrice);
        const cardProductMedia = card.querySelector(this.selectors.carProductMedia);

        cardLinks.forEach((cardLink) => {
          cardLink.setAttribute('href', swatchLink);
          cardLink.innerHTML = swatchTitle;
        });

        if (cardPrice) {
          cardPrice.innerHTML = swatchPrice;
        }

        if (cardComparePrice) {
          cardComparePrice.innerHTML = swatchComparePrice;
        }

        if (cardProductMedia) {
          cardProductMedia.innerHTML = swatchMedia;
        }
      }
    },
  );
}
